export const companyStatusEnum = {
  Pending: 1,
  Verified: 2,
  Rejected: 3,

  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};

export const companyStatusColorEnum = colors => ({
  [companyStatusEnum.Pending]: {
    color: colors.blueMain,
    backgroundColor: colors.blueLight,
  },
  [companyStatusEnum.Verified]: {
    color: colors.greenMain,
    backgroundColor: colors.greenLight,
  },
  [companyStatusEnum.Rejected]: {
    color: colors.redDark,
    backgroundColor: colors.redLight,
  },
});
